import { call, put, takeEvery } from 'redux-saga/effects'

function* storeData(action) {
    if (action.data) {
        yield put({ type: 'STORE_SELECTED_TYPES_SUCCESS', data: action.data });
    } else {
        yield put({ type: 'STORE_SELECTED_TYPES_FAILED', message: "no data" });
    }
}

function* selectedTypesSaga() {
    yield takeEvery('STORE_SELECTED_TYPES_REQUESTED', storeData);
}

export default selectedTypesSaga;